<template>
    <div class="wrapper-tfb animated fadeIn">
        <div class="card fts-table-wrapper">
            <div class="card-header">
                <div>List</div>
            </div>

            <div class="card-body">
                <div class="filter-row">
                    <div class="search-box">
                        <input type="text" class="form-control" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                    </div>
                    <div class="management-list-control text-right">

                    </div>
                    <div class="size-page-wrapper text-right">
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div class="fts-table table-responsive-sm">
                    <table  v-if='transactionList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment table-tfb">
                        <thead role="rowgroup">
                            <tr role="row">
                                <th v-on:click="changesSort" role="columnheader" aria-colindex="1" aria-label="ID" aria-sort="none">ID</th>
                                <th v-on:click="changesSort" role="columnheader" aria-colindex="2" aria-label="Client" aria-sort="none">Client</th>
                                <th v-on:click="changesSort" role="columnheader" aria-colindex="3" aria-label="Rate Plan" aria-sort="none">Rate Plan</th>
                                <th v-on:click="changesSort" role="columnheader" aria-colindex="4" aria-label="No Of SIMs" aria-sort="none">No Of SIMs</th>
                                <th v-on:click="changesSort" role="columnheader" aria-colindex="5" aria-label="BAN Number" aria-sort="none">BAN Number</th>
                                <th v-on:click="changesSort" role="columnheader" aria-colindex="6" aria-label="Dealer Code" aria-sort="none">Dealer Code</th>
                                <th v-on:click="changesSort" role="columnheader" aria-colindex="7" aria-label="Status" aria-sort="none">Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in transactionList" :data-iccid="item.iccid" v-bind:key="index">
                                <td v-on:click="goToDetails(item.id)">{{item.id}}</td>
                                <td v-on:click="goToDetails(item.id)">{{item.company.name}}</td>
                                <td v-on:click="goToDetails(item.id)">{{item.ratePlan.name}}</td>
                                <td v-on:click="goToDetails(item.id)">{{item.iccids.length}}</td>
                                <td v-on:click="goToDetails(item.id)"><span v-if="item.ban">{{item.ban}}</span><span v-else>-</span></td>
                                <td v-on:click="goToDetails(item.id)"><span v-if="item.dealerCode">{{item.dealerCode}}</span><span v-else>-</span></td>
                                <td v-on:click="goToDetails(item.id)">
                                    <span v-if="item.state == 'NEW'">New</span>
                                    <span v-if="item.state == 'AWAITING_SIGNOFF'">Unassigned</span>
                                    <span v-if="item.state == 'AWAITING_PROCESSING'">Queued</span>
                                    <span v-if="item.state == 'IN_PROCESSING'">Processing</span>
                                    <span v-if="item.state == 'PROCESSED_OK'">Completed</span>
                                    <span v-if="item.state == 'PROCESSED_ERROR'">Failed</span>
                                    <span v-if="item.state == 'PROCESSED_PARTIALLY'">Partially Completed</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="fts-bottom-table">
                        <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                            <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                        </nav>
                        <button class="btn btn-primary btn-on-right" @click="showExportSelect()">Export TFB queue</button>
                    </div>

                    <div class="loader-transaction-list" v-if="loadingTransaction == true && noTransaction == false">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>
                    </div>

                    <div class="no-transaction" v-if="noTransaction == true && loadingTransaction == false">
                        <h2 class="text">You have no Transaction</h2>
                    </div>
                </div>
            </div>
        </div>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from '../../variables'
import Paginate from 'vuejs-paginate'

export default {
    name: 'TFBQueue',
    data() {
        return {
            filter: null,
            sortSettings: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true
            },
            transactionList: [],
            selectedSims: 0,
            paginationCount: 0,
            searchString: '',
            typingTimer: '',
            noTransaction: false,
            loadingTransaction: true,
            interval: '',
        }
    },
    components: {
        Paginate: Paginate
    },
    methods: {
        searchKeyUp() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchRow()
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.typingTimer)
        },
        searchRow() {
            this.loadingTransaction = true;
            if (this.filter.length > 0) {
                this.searchString = `&search=${escape(this.filter)}`
            } else {
                this.searchString = ''
            }
            this.getTransationList(true);
        },
        getPagination() {
            Axios.get(`${globalStore.data.restApiUrl}/queues/activations/page-count?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=true${this.searchString}`)
                .then(response => {
                    this.paginationCount = response.data
                }).catch(error => {
                    console.log(error);
                })
        },
        sizePage() {
            this.loadingTransaction = true
            this.getTransationList(true);
        },
        selectAllRows() {},
        changesSort(ev) {
            this.sortSettings.sort = ev.target.getAttribute("aria-colindex");

            if (ev.target.getAttribute("aria-sort") == 'none') {
                document.querySelectorAll("table.table-tfb thead th[aria-sort]").forEach(item => {
                    item.setAttribute("aria-sort", 'none')
                })
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettings.desc = false
            } else if (ev.target.getAttribute("aria-sort") == 'ascending') {
                ev.target.setAttribute("aria-sort", 'descending')
                this.sortSettings.desc = true
            } else if (ev.target.getAttribute("aria-sort") == 'descending') {
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettings.desc = false
            }
            this.loadingTransaction = true;
            this.getTransationList(true);
        },
        paginationControll(ev) {
            this.loadingTransaction = true
            this.sortSettings.page = ev;
            this.getTransationList(false);
        },
        getTransationList(notPagination) {
            let checkTransactionStatus = 0;
            if (notPagination){
                this.sortSettings.page = 1;
                this.getPagination();
            }
            Axios.get(`${globalStore.data.restApiUrl}/queues/activations?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}${this.searchString}`)
                .then(response => {
                    this.transactionList = response.data;
                    this.loadingTransaction = false;

                    for (let item of this.transactionList) {
                        if (item.state == "AWAITING_PROCESSING" || item.state == "IN_PROCESSING" || item.state == "NEW") {
                            checkTransactionStatus++
                        }
                    }

                    if (checkTransactionStatus > 0) {
                        this.checkInterval();
                    }

                    this.noTransaction = (this.transactionList.length == 0) ? true : false
                }).catch(error => {
                    console.log(error);
                })
        },
        checkInterval() {
            if (this.$router.currentRoute.name == 'TFBQueue') {
                this.interval = setTimeout(() => {
                    this.getTransationList(false);
                }, 10000)
            } else {
                clearTimeout(this.interval)
            }
        },
        goToDetails(id) {
            this.$router.push(`/admin/tfb-queue/${id}`)
        },
        hideExportSelect() {
            this.$refs['fileFormatModal'].hide()

        },
        showExportSelect() {
            this.$refs['fileFormatModal'].show()
        },
        exportCsv() {
            this.$refs['fileFormatModal'].hide()

            Axios.get(globalStore.data.restApiUrl + "/queues/activations/csv")
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', 'TFB list.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportXlsx() {
            this.$refs['fileFormatModal'].hide()

            Axios.get(globalStore.data.restApiUrl + "/queues/activations/xlsx", {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', 'TFB list.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        }
    },
    created() {
        this.getTransationList(true)
    },
    beforeDestroy() {
        clearTimeout(this.interval);
    }
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
.wrapper-tfb {
    .card-header {
        display: flex;
        justify-content: space-between;
    }

    .card-body {
        .col-md-2.text-right {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            label {
                margin: 0;
            }

            select {
                max-width: 100px;
                margin-left: 10px;
            }
        }
    }

    .fts-bottom-table {
        justify-content: center;
    }
}

.table-navigation {
    margin-top: 20px;
}

.dark-theme {
    .loader-transaction-list,
    .no-transaction {
        background-color: rgba(0, 0, 0, 0.4);
    }
}

.loader-transaction-list,
.no-transaction {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: rgba(255, 255, 255, 0.7);

    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .sk-wave {
        height: 60px;
        .sk-rect {
            width: 3px;
            background-color: #39c354;
            border-radius: 4px;
        }
    }

    .text {
        margin-top: 20px;
        text-align: center;
        font-size: 15px;
        font-weight: 700;
    }

    h2.text {
        margin-top: 180px;
    }
}

.no-transaction {
    position: relative;
    h2.text {
        margin: 0;
    }
}

#fileFormatModal___BV_modal_header_ {
    padding-bottom: 0;
}

#fileFormatModal___BV_modal_body_ {
    padding-top: 0;
    .file-format-popup {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        padding: 0 20px 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }

        .close-icon {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
    }
}

.fts-bottom-table {
     position: relative;
     .btn-on-right {
         position: absolute;
         top: 40px;
         right: 20px;
     }
 }

.dark-theme {
    .table thead th {
        color: #fff;
        border-color: #1A1C1D;
    }
    .table tbody tr td {
        border-color: #1A1C1D;
        color: #fff;
    }
    .table tbody tr:nth-of-type(even) td {
        background-color: #3a4149;
    }
    .table tbody tr:nth-of-type(odd) td {
        background-color: #2F353A;
    }
    .table tbody tr:hover td {
        background-color: #0088FF;
        color: #fff;
    }
    .table tbody tr[aria-selected="true"] td {
        background-color: #0088FF;
        color: #fff;
    }

    #fileFormatModal___BV_modal_content_ {
        background-color: #3a4149;
        color: #EDEEEF;

        button {
            color: #fff;
        }
        .file-format-popup {
            background-color: #3a4149;
            color: #EDEEEF;
        }

        .modal-body {
            button.btn-light {
                color: #23282c;
            }
        }
    }
}
</style>
